import { render, staticRenderFns } from "./StepDemographics.vue?vue&type=template&id=675b2770&"
import script from "./StepDemographics.vue?vue&type=script&lang=js&"
export * from "./StepDemographics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports